import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import BlockRenderer from "../components/structured-text/block-renderer";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";

const BonePage = ({ pageContext, data }) => {

    return (
        <>
            <DraftDebug publishedAt={data?.datoCmsBonePage?.meta?.publishedAt} />
            <HelmetDatoCms seo={data?.datoCmsBonePage?.seoMetaTags}>
                <body className={`page-template page-template--${data?.datoCmsBonePage?.slug === 'index' ? 'home' : data?.datoCmsBonePage?.slug}`} />
            </HelmetDatoCms>
            <BlockRenderer data={data?.datoCmsBonePage?.blocks} brand={`bone`} />
        </>
    )
}

export const query = graphql`
    query BonePageTemplate ($originalId: String!) {
        datoCmsBonePage(originalId: { eq: $originalId }) {
            seoMetaTags {
                tags
            }
            jsonLd
            slug
            meta {
                publishedAt
            }
            blocks {
                __typename
                ...LandingBannerProps
                ...RecipeSelectorProps
                ...AwardsCtaProps
                ...BasicCtaProps
                ...BasicPageProps
                ...TestimonialProps
                ...ThreeColumnItemProps
                ...RangeSliderItemProps
                ...TitleContentCategoryProps
                ...TitleContentVideoItemProps
                ...MapLottieProps
                ...TitleClientProps
                ...TitleHeaderProps
                ...ProductCtaProps
                ...BurgerCampaignProps
                ...CampaignTitleGalleryContentProps
                ...CampaignTitleContentImageProps
                ...BurgerColumnItemProps
                ...RequestSampleProps
                ...ThankYouProps
                ...LinktreeProps
                ...BurgerColumnItemProps
            }
        }
    }
`
export default BonePage
